import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Box, Text, Tooltip } from '@betterment/samba-react';
import { HR } from '@betterment/style-closet-react';

import ReffableIcon from './ReffableIcon';

import { TextShimmerLoader } from '../../Shared/components/ShimmerLoaders';
import { useFourOhOneKContributionsAllTimeQuery } from '../hooks';

const AllTimeContributions: React.FC<React.PropsWithChildren> = () => {
  const { isLoading, fourOhOneKContributionsAllTime } = useFourOhOneKContributionsAllTimeQuery();

  return (
    <Box css={{ mt: 'space.200' }}>
      {isLoading && <TextShimmerLoader numLines={2} />}
      {!isLoading && fourOhOneKContributionsAllTime && (
        <>
          <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Box css={{ display: 'flex', flexDirection: 'row' }}>
              <Text css={{ marginRight: 'space.25' }}>Total contributions</Text>
              <Tooltip>
                <Tooltip.Trigger asChild={true}>
                  <ReffableIcon css={{ verticalAlign: 'middle' }} name="InfoCircle" size="small" />
                </Tooltip.Trigger>
                <Tooltip.Content side="bottom">
                  <Tooltip.Text>
                    Total contributions does not include market changes and only represents deposits and rollovers you
                    have made into your 401(k)
                  </Tooltip.Text>
                </Tooltip.Content>
              </Tooltip>
            </Box>
            <Text>{formatMoney(fourOhOneKContributionsAllTime.amount)}</Text>
          </Box>
          <HR my="6" />
          {fourOhOneKContributionsAllTime.lineItems.map(lineItem => {
            return (
              <Box key={lineItem.id}>
                <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Text variant="text50" color="text.weak">
                    {lineItem.name}
                  </Text>
                  <Text variant="text50" color="text.weak">
                    {formatMoney(lineItem.amount)}
                  </Text>
                </Box>
                <HR my="6" />
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
};

export default AllTimeContributions;
